import PaymentsReportRoutes from './payments/routes';
import SalesLedgerRoutes from './SalesLedgerIframe/routes';
import InventoryRoutes from './inventory/routes';

export default [...PaymentsReportRoutes, ...SalesLedgerRoutes, ...InventoryRoutes];
